<template>
  <div class="deck px-[20px] pt-[10px] pb-[20px] bg-white rounded-sm">
    <CruiseDetailCommenTitle class="mb-[10px]" title="甲板信息" :subtitle="`共${data.length}层`" />
    <div class="relative">
      <swiper class="w-[916px] flex flex-grow !pb-[20px]" :options="swiperOptions" v-if="data.length">
        <swiper-slide class="voyage__item relative" v-for="(deck, index) in decks" :key="index">
          <ul class="flex flex-wrap mb-[-40px] pl-[5px] pt-[5px]">
            <li class="deck__item cursor-pointer flex flex-col items-center justify-center mb-[40px] mr-[5px] relative"
              v-for="item in deck" @click="$emit('clickDeck', item.floor)">
              <el-image class="w-[74px] h-[317px] mb-[20px]" fit="contain" :src="item.plan" lazy></el-image>
              <div class="text-xs text-[#000]" v-if="item.floor">第{{ item.floor }}层</div>
              <div class="deck__item__tag" v-if="item.name">{{ item.name }}</div>
            </li>
          </ul>
        </swiper-slide>
      </swiper>
      <div class="flex items-center justify-center" v-if="data.length > 14">
        <div class="n-swiper-button-prev swiper__page" slot="button-prev">
          <i class="ficon ficon-a-Vector130 text-white leading-0 transform rotate-180"></i>
        </div>
        <div class="n-swiper-pagination" slot="pagination"></div>
        <div class="n-swiper-button-next swiper__page" slot="button-next">
          <i class="ficon ficon-a-Vector130 text-white leading-0"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DetailBlock from "@/views/company/CruiseDetailBlock.vue";
import CruiseDetailCommenTitle from "@/views/company/CruiseDetailCommenTitle.vue"
// import VImg from "@/components/VImg";
import Img from "@/assets/img/global/home/resources/5e537b.jpg";
import IMG_NO_DECK from "@/assets/img/company/cruise-detail/none-deck.png";
import { chunk } from 'lodash'

export default {
  name: "DetailDeck",
  components: {
    DetailBlock,
    CruiseDetailCommenTitle,
    // VImg,
  },
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      Img,
      navActiveIndex: 1,
      IMG_NO_DECK,
      swiperOptions: {
        // lazy: {
        //   loadPrevNext: true
        // },
        loop: false,
        slidesPerView: 'auto',
        pagination: {
          el: '.n-swiper-pagination',
        },
        navigation: {
          nextEl: '.n-swiper-button-next',
          prevEl: '.n-swiper-button-prev',
        },
        // scrollbar: {
        //   el: '.swiper-scrollbar',
        //   draggable: true,
        // },
      }
    };
  },
  computed: {
    decks() {
      return chunk(this.data, 14)
    }
  },
};
</script>

<style lang="scss" scoped>
.deck__item {
  border-color: transparent;
  border-radius: 0.25rem;
  border-width: 1px;
  height: 397px;
  width: 125px;
  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.17);
}
.deck__item:hover {
  --tw-border-opacity: 1;
  border-color: rgba(0, 94, 220, var(--tw-border-opacity));
}
.deck__item__tag {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  font-weight: 500;
  height: 20px;
  font-size: 12px;
  line-height: 1;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 18px;
  padding-left: 10px;
  position: absolute;
  top: 0px;
  left: 0px;
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
  border-radius: 0 0 20px 0;
}
.deck .swiper__page {
  --tw-bg-opacity: 1;
  background-color: rgba(182, 187, 200, var(--tw-bg-opacity));
  border-radius: 50%;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 28px;
  margin-left: 30px;
  margin-right: 30px;
  width: 28px;
}
.deck .n-swiper-pagination ::v-deep .swiper-pagination-bullet {
  --tw-bg-opacity: 1;
  background-color: rgba(182, 187, 200, var(--tw-bg-opacity));
  border-radius: 3px;
  height: 3px;
  margin-left: 4px;
  margin-right: 4px;
  width: 12px;
}
.deck .n-swiper-pagination ::v-deep .swiper-pagination-bullet-active {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 0, 0, var(--tw-bg-opacity));
}
</style>
